import { useState } from "react";
import api from "@/api/api.js";
import { Form, Button, Row, Col, Card, CardBody } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CertificateUpload from "@/pages/user/Contacts/CertificateUpload.jsx";
import { capitalizeFirstLetter } from "@/utils/stringUtils.js";
import { useNavigate } from "react-router-dom";

const CompanyContactsCreate = () => {
  const userId = sessionStorage.getItem("user");
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    taxIdentification: "",
    businessName: "",
    type: "",
    street: "",
    exterior: "",
    interior: "",
    suburb: "",
    town: "",
    state: "",
    postalCode: "",
    phone: "",
    emailContact: "",
    user: `/api/users/${userId}`,
  });
  const { t } = useTranslation();

  const REQUIRED_FIELDS = [
    "taxIdentification",
    "businessName",
    "type",
    "street",
    "exterior",
    "interior",
    "suburb",
    "town",
    "state",
    "postalCode",
  ];

  const handleUploadSuccess = (data) => {
    const { id, edit, fields } = data.contact;

    if (!edit) {
      navigate("/contacts");
      return;
    }

    const params = new URLSearchParams();
    Object.entries(fields).forEach(([key, value]) => {
      params.append(key, value);
    });

    navigate(`/contacts/${id}/edit?${params.toString()}`);
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      let response = await api.post("/contacts", formData);
      navigate(`/contacts/${response.data.id}/show`);
    } catch (err) {
      console.error(err);
      setError(t("ui.clientCreateError"));
    } finally {
      setSaving(false);
    }
  };
  return (
    <>
      <Col xs={12}>
        <Card>
          <CardBody>
            <CertificateUpload onUploadSuccess={handleUploadSuccess} />
          </CardBody>
        </Card>
      </Col>
      <div className="col">
        <div className="card">
          <div className="card-body">
            <Form onSubmit={handleSubmit}>
              {error && <div className="alert alert-danger">{error}</div>}
              <Row className="g-2">
                {Object.entries(formData)
                  .filter(([key]) => key !== "user")
                  .map(([key, value]) => (
                    <Col md={6} key={key}>
                      <Form.Group controlId={key}>
                        <Form.Label>
                          {capitalizeFirstLetter(t(key))}
                          {REQUIRED_FIELDS.includes(key) && (
                            <span className="text-danger ms-1">*</span>
                          )}
                        </Form.Label>

                        {key === "type" ? (
                          <Form.Select
                            name={key}
                            value={value}
                            onChange={handleChange}
                            required={REQUIRED_FIELDS.includes(key)}
                          >
                            <option value="">Seleccione...</option>
                            <option value="física">Física</option>
                            <option value="moral">Moral</option>
                          </Form.Select>
                        ) : (
                          <Form.Control
                            type="text"
                            name={key}
                            value={value}
                            onChange={handleChange}
                            required={REQUIRED_FIELDS.includes(key)}
                          />
                        )}
                      </Form.Group>
                    </Col>
                  ))}
              </Row>
              <div className="d-flex align-items-center gap-2 mt-3 mb-2">
                <Button type="submit" variant="primary" disabled={saving}>
                  {saving ? "Guardando..." : t("ui.createClient")}
                </Button>
                <Button variant="secondary" onClick={() => navigate(-1)}>
                  Cancelar
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyContactsCreate;
